module.exports = __webpack_public_path__ + "img/statistic-number-prim.1cbab28.svg";